<template>
    <div>
        <h3>Basic technical requirements</h3>
        <p>These requirements are the same for all frontend stacks</p>
        <ul>
            <li>Version your code using <a href="https://github.com/" target="_blank">git</a></li>
            <li>Get dependencies using <a href="http://npmjs.com/" target="_blank">npm</a></li>
            <li>Have a <i>local development</i> server</li>
            <li>Have a <i>production build</i> that outputs files for <i>static hosting</i></li>
            <li>Have a <i>responsive</i> layout</li>
            <li>Refreshig the page should return the user to the same view / state</li>
            <li>Use the <i>HTML5 History API</i> for intuitive navigation (most likely you will get this by the router)</li>
            <li>Have basic unit tests of your business logic as part of the build</li>
            <li>Use <i>CSS3</i> and <i>HTML5</i></li>
            <li>Write next-gen javascript (<i>ES6+</i>), and rely on <i>Babel</i> to transpile it</li>
            <li>Consider an external lib such as <a href="https://github.com/axios/axios" target="_blank">axios</a> for better handling of REST-calls</li>
            <li>Be <i>fault-tolerant</i> <span class="comment">/* expect things to fail */</span></li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'FrontendTechReq'
}
</script>